// components/IndustriesSection.jsx
import { useState } from 'react';
import SectionReveal from './SectionReveal';

export default function IndustriesSection({ t }) {
  const [activeIndustry, setActiveIndustry] = useState(0);
  const [animKey, setAnimKey] = useState(0);

  const industries = t?.industries || [];

  if (!industries.length) return null;

  const activeData = industries[activeIndustry] || industries[0];

  const prevIndustry = () => {
    setAnimKey(prev => prev + 1);
    setActiveIndustry((prev) => (prev === 0 ? industries.length - 1 : prev - 1));
  };

  const nextIndustry = () => {
    setAnimKey(prev => prev + 1);
    setActiveIndustry((prev) => (prev === industries.length - 1 ? 0 : prev + 1));
  };

  const selectIndustry = (idx) => {
    setAnimKey(prev => prev + 1);
    setActiveIndustry(idx);
  };

  return (
    <section id="industries" className="relative bg-white px-3 py-20 md:px-10">
      
      <div className="mx-auto max-w-7xl space-y-12">
        
        {/* Заголовок */}
        <SectionReveal>
          <div className="border-l-4 border-[#0FA4E8] bg-gray-50 p-6 md:p-10">
            <h2 className="text-2xl md:text-4xl font-black text-[#0B3B6F] uppercase mb-3">
              {t?.industriesTitle || 'Ոլորտներ'}
            </h2>
            <p className="text-lg font-bold text-[#0B3B6F] mb-2">
              {t?.industriesSubtitle || 'Լուծումներ յուրաքանչյուր ոլորտի համար'}
            </p>
            <p className="text-sm md:text-base text-slate-600 leading-relaxed max-w-3xl">
              {t?.industriesDesc || ''}
            </p>
          </div>
        </SectionReveal>

        {/* Слайдер */}
        <SectionReveal delay={150}>
          <div className="border-l-4 border-[#0B3B6F] overflow-hidden">
            
            {/* Верхняя панель */}
            <div className="flex items-center justify-between bg-gray-50 p-3 md:p-4">
              
              <button
                onClick={prevIndustry}
                className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-white border border-gray-400 hover:border-[#0FA4E8] hover:text-[#0FA4E8] transition-all text-[#0B3B6F]"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M15 18l-6-6 6-6"/>
                </svg>
              </button>

              <div className="flex-1 flex items-center justify-center gap-3 px-4">
                <span className="text-[#0FA4E8]" dangerouslySetInnerHTML={{ __html: activeData.icon }} />
                <span className="text-sm md:text-base font-bold text-[#0B3B6F]">
                  {activeData.title}
                </span>
              </div>

              <button
                onClick={nextIndustry}
                className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-white border border-gray-400 hover:border-[#0FA4E8] hover:text-[#0FA4E8] transition-all text-[#0B3B6F]"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M9 18l6-6-6-6"/>
                </svg>
              </button>
            </div>

            {/* Контент */}
            <div key={animKey} className="md:grid p-3 md:grid-cols-5">
              
              {/* Фото */}
              <div className="md:col-span-2 relative h-64 md:h-full min-h-[350px] overflow-hidden">
                <img 
                  src={activeData.image}
                  alt={activeData.title}
                  className="absolute inset-0 w-full h-full object-cover animate-zoomIn"
                />
                <div className="absolute inset-0 bg-[#0B3B6F]/10" />
              </div>

              {/* Список */}
              <div className="md:col-span-3 bg-gray-50 p-5 md:p-10">
                <p className="text-sm text-slate-500 mb-4 md:mb-6 animate-slideUp">
                  {activeData.desc}
                </p>
                <div className="grid gap-2 sm:grid-cols-2">
                  {activeData.items.map((item, idx) => (
                    <div 
                      key={idx} 
                      className="flex items-center gap-3 p-3 bg-white border border-gray-100 hover:border-[#0FA4E8]/30 transition-all group animate-slideUp"
                      style={{ animationDelay: `${150 + idx * 50}ms` }}
                    >
                      <span className="flex-shrink-0 text-[#0FA4E8]">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                      </span>
                      <span className="text-sm font-medium text-[#0B3B6F] group-hover:text-[#0FA4E8] transition-colors">
                        {item}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

            </div>

            {/* Точки + счётчик */}
            <div className="flex items-center justify-between p-3 bg-gray-50">
              <span className="text-xs text-slate-400 font-medium">
                {String(activeIndustry + 1).padStart(2, '0')} / {String(industries.length).padStart(2, '0')}
              </span>
              <div className="flex gap-2">
                {industries.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => selectIndustry(idx)}
                    className={`w-2 h-2 rounded-full transition-all ${
                      idx === activeIndustry ? 'bg-[#0FA4E8] w-6' : 'bg-gray-300 hover:bg-gray-400'
                    }`}
                  />
                ))}
              </div>
            </div>

          </div>
        </SectionReveal>

      </div>
    </section>
  );
}